import { compose, flattenProp } from 'recompose';
import { connect } from 'react-redux';
import { addProps, addIntlProps } from 'utils/recompose';
import { injectIntl } from 'react-intl';
import messages from './messages';
import { series, firstModelWithUnsubmitted } from 'reducers/series/selectors';
import { mini, addDisclaimer } from 'reducers/dashboard/selectors';
import combineSelectors from 'utils/combineSelectors';
import styles from './styles.module.scss';

const mapStateToProps = combineSelectors({
  series,
  firstModelWithUnsubmitted,
  mini,
  addDisclaimer,
});

export const modelUrl = ({ seriesId, firstModelWithUnsubmitted }) => {
  let modelUrl = firstModelWithUnsubmitted
    ? `/series/${seriesId}/models/${firstModelWithUnsubmitted}`
    : '';
  return modelUrl;
};

export const stylesNameSize = ({ name, mini }) => {
  if (mini) {
    return styles.mini;
  } else {
    if (name.length <= 2) {
      return styles.large;
    } else {
      return styles.medium;
    }
  }
};

export const stylesCarImageSize = ({ name }) =>
  name.length > 2 ? styles.carImageSmall : styles.carImageRegular;

export const unavailable = ({ totalQuota }) => parseInt(totalQuota, 10) === 0;

export const stylesRoot = ({ unavailable }) =>
  unavailable ? styles.unavailable : undefined;

export const selected = ({ seriesId, selectedSeriesId }) =>
  seriesId === selectedSeriesId;

export const stylesArrow = ({ selected, leftmostPanel }) => {
  if (selected && leftmostPanel) {
    return styles.selectedLeftmostPanel;
  } else if (selected) {
    return styles.selectedOtherPanel;
  } else {
    return styles.unselected;
  }
};

export default compose(
  connect(mapStateToProps),
  flattenProp('series'),
  addProps({
    unavailable,
  }),
  addProps({
    stylesNameSize,
    stylesCarImageSize,
    stylesRoot,
  }),
  addProps({ selected }),
  addProps({ stylesArrow }),
  injectIntl,
  addIntlProps({
    messages,
    propNames: ['inCartString', 'remainingString', 'submittedString'],
  }),
  addProps({
    modelUrl,
  }),
);
